import { PatientInformation } from "~/providers/components";

export const LeadPatientInformation = () => <PatientInformation />;
